/* eslint-disable max-lines-per-function */
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerTrigger,
  ScrollArea,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui';
import { useErfahrungslevelOptions } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useErfahrungslevelOptions';
import {
  faAnglesUpDown,
  faCheck,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ErfahrungslevelSelect({
  value,
  handleChange,
}: {
  value: string;
  handleChange: (value: string) => void;
}) {
  const { t } = useTranslation();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const options = useErfahrungslevelOptions();

  const selectedErfahrungslevel = options.find((ab) => ab.key === value);
  return (
    <div>
      <Select value={value} onValueChange={handleChange}>
        <SelectTrigger className="hidden md:flex border-neutrals-300">
          <SelectValue
            placeholder={t(
              `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.placeholder`,
            )}
          />
        </SelectTrigger>
        <SelectContent align="start">
          {options.map((option) => (
            <SelectItem key={option.key} value={option.key}>
              <ErfahrungsLevelItem erfahrungslevel={option} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
        <DrawerTrigger className="flex md:hidden" asChild>
          <Button
            className="md:hidden flex flex-row justify-between gap-1 w-full text-neutrals-900 text-sm font-normal"
            variant="outline-secondary"
            role="combobox">
            <span className="truncate">
              {selectedErfahrungslevel ? (
                <ErfahrungsLevelItem
                  erfahrungslevel={selectedErfahrungslevel}
                />
              ) : (
                t(
                  `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.placeholder`,
                )
              )}
            </span>
            <FontAwesomeIcon icon={faAnglesUpDown} />
          </Button>
        </DrawerTrigger>
        <DrawerContent className="flex flex-col gap-4 p-4">
          <div className="font-semibold text-center">
            {t(
              `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.erfahrungslevel.label`,
            )}
          </div>

          <ScrollArea className="overflow-auto">
            <div className="flex flex-col gap-2">
              {options.map((option) => (
                <div
                  className="flex flex-col gap-2 not-last:border-b border-neutrals-200 pb-2"
                  key={option.key}
                  onClick={() => {
                    handleChange(option.key);
                    setIsDrawerOpen(false);
                  }}>
                  <ErfahrungsLevelItem
                    erfahrungslevel={option}
                    selected={option.key === selectedErfahrungslevel?.key}
                  />
                </div>
              ))}
            </div>
          </ScrollArea>
        </DrawerContent>
      </Drawer>
    </div>
  );
}

function ErfahrungsLevelItem({
  erfahrungslevel,
  selected,
}: {
  erfahrungslevel: { name: string; icon: IconDefinition };
  selected?: boolean;
}) {
  return (
    <div className="flex flex-row gap-2 items-center">
      <FontAwesomeIcon icon={erfahrungslevel.icon} />
      <span className="text-neutrals-900 text-sm font-normal">
        {erfahrungslevel.name}
      </span>
      {selected && (
        <FontAwesomeIcon
          icon={faCheck}
          className="text-primary-blue-600 ml-auto"
        />
      )}
    </div>
  );
}
